export const messages = {
  en: {
    deletePartnerGoods: {
      confirmTitle: 'Please confirm your operation!',
      confirmContent: 'Confirm to delete partner goods',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    deletePartnerGoods: {
      confirmTitle: '请确认您的操作!',
      confirmContent: '确定删除合作商品',
      cancel: '点错了',
      confirm: '确认删除!',
      deleteSuccess: '删除成功'
    }
  }
}